import * as turf from '@turf/turf'
import download from 'downloadjs'
import { jStat } from 'jstat'
import { v4 as uuidv4 } from 'uuid'
import { gmapApi } from 'vue2-google-maps'
import { mapActions, mapGetters, mapMutations } from 'vuex'

import {
	getPlanejamentoAmostrasSingleTrees,
	getPlanejamentoConcentradorLongRangeInstalacao,
	getPlanejamentoDeInventarioFlorestalContinuo,
	getPlanejamentoDeInventarioFlorestalDeQualidade,
	getPlanejamentoDeInventarioFlorestalInstalacao,
	getPlanejamentoDeInventarioFlorestalPreCorte,
} from '../services/requests/OrdemDeServicoRequests'

import { recuperarMaiorNumeroDeCodigoDeParcelaParaOPlantio } from '../services/requests/PlanejamentoDeOrdemDeServicoTradicionalRequests'

import { recuperarNumeroDeFustesDoPlantio } from '../services/requests/PlanejamentoDeOrdemDeServicoSingleTreesRequests'

import { buscarPlanejamentoOrdemDeServicoDePilha } from '../services/requests/PlanejamentoDeOrdemDeServicoDePilhaRequests'

const mixins = {
	data() {
		return {
			model: {
				orsv_is_cv: false,
				orsv_tx_metodologia_amostral: 'Sistematico',
				id: '',
				orsv_nr_amostra_total: 0,
				orsv_is_bitterlich: false,
				orsv_nr_intensidade_amostral: 0,
				orsv_dt_data_inicial: '',
				orsv_dt_prazo_final: '',
				orsv_tx_forma_parcela: '',
				orsv_md_medida_parcela: null,
				orsv_md_geofence: null,
				orsv_ds_descricao: '',
				fk_esfl_estrato_florestal: '',
				fk_tpsv_tipo_servico: '',
				orsv_nr_buffer: 0,
				fk_exos: [],
				tpsv_cd_codigo: '',

				dataInicial: '',
				prazoFinal: '',
				finalizacaoDaOs: '',

				prePreencherEstruturaInventarioAnterior: false,
				verificarConsistencia: false,
				inventarioReferencia: undefined,

				// Campos da etapa Operação
				orsv_dt_hora_inicio_medicao: '',
				orsv_tx_frequencia_coleta: '',
				orsv_tx_periodo_disponivel: '',
				orsv_tx_versao_dendrometro: '',
			},
			parcelas: [],
			codigoDeParcelaEmUsoNoBanco: [],
			parcelasToUpdate: [],
			parcelasToDelete: [],
			bufferParcela: undefined,
			bufferTalhao: undefined,
			coeficienteVariacao: {
				amostrasReferencia: undefined,
				targetErro: undefined,
				coeficiente: undefined,
			},
			hectareParcela: undefined,
			totalParcela: undefined,
			metodologias: {
				Aleatorio: this.gerarParcelasAleatorio,
				AleatorioSistematico: this.gerarParcelasAleatorioSistematico,
				Sistematico: this.gerarParcelasSistematico,
			},
			numeroDeFustes: undefined,
			getPlanejamentoOrdemServico: {
				'001': this.getInventarioFlorestalInstalacao,
				'002': this.getInventarioFlorestalContinuo,
				'003': this.getInventarioFlorestalPreCorte,
				'007': this.getPlanejamentoSingleTrees,
				'009': this.getPlanejamentoConcentradorLongRange,
				'018': this.getPlanejamentoOrdemDeServicoDePilha,
				'019': this.getInventarioFlorestalDeQualidade,
			},
			ordemDeServicoDePilha: undefined,
			buscandoOrdemDePilha: false,
		}
	},
	methods: {
		...mapActions('moduleImportShape', ['setAllShapes']),
		...mapMutations('moduleImportShape', [
			'resetState',
			'setGeoJsonFzda',
			'setGeoJsonTlho',
			'setGeoJsonBufferTalhao',
			'setGeoJsonBufferParcela',
			'setGeoJsonPtio',
			'setFzdaHasFileInDB',
			'setTlhoHasFileInDB',
			'setPtioHasFileInDB',
		]),
		isInAnyPlantio(point) {
			return this.getGeoJsonPtio.features.some((feature) =>
				turf.booleanPointInPolygon(point, feature),
			)
		},
		iconeParcela({ codigo, draggable, selected, color }) {
			return {
				title: codigo,
				path: this.google?.maps.SymbolPath.CIRCLE || 0,
				fillColor: color || 'blue',
				fillOpacity: 1,
				strokeColor: selected ? 'yellow' : 'white',
				strokeWeight: 0.5,
				scale: 5,
				draggable,
			}
		},
		handleResponseInventario({ data }) {
			var { fazenda, talhoes, plantios } = data.result.maps[0]

			this.setAllShapes({
				fazenda: JSON.parse(fazenda),
				talhoes: JSON.parse(talhoes),
				plantios: JSON.parse(plantios),
			})

			const { estratosFlorestais } = data.result

			estratosFlorestais.forEach((estratoFlorestal) => {
				let marcador = 'parcelas'

				if (this.isSingleTrees) {
					marcador = 'amostras'
				} else if (this.codigoTipoServico === '009') {
					marcador = 'marcadores'
				}

				estratoFlorestal[marcador]
					.filter((marcador) => {
						if (this.model.inventarioReferencia) {
							return marcador.medicoesVinculadas.includes(this.model.inventarioReferencia)
						}
						return marcador
					})
					.forEach((marcador) => {
						marcador.isContinuo = estratoFlorestal.isContinuo
						marcador.icon = this.iconeParcela({
							draggable: !(
								(!!marcador.estratoFlorestalId && this.model.tpsv_cd_codigo === '001') ||
								this.model.tpsv_cd_codigo === '002' ||
								this.model.tpsv_cd_codigo === '003' ||
								this.model.tpsv_cd_codigo === '007' ||
								this.model.tpsv_cd_codigo == '019'
							),
						})
						this.adicionaParcela({
							codigo: marcador.codigo,
							area: marcador.area,
							coordenadaX: marcador.coordenadaX || marcador.coordenadaProvisionadaX,
							coordenadaY: marcador.coordenadaY || marcador.coordenadaProvisionadaY,
							dataDeFechamento: marcador.dataDeFechamento,
							dataDeInstalacao: marcador.dataDeInstalacao,
							icon: marcador.icon,
							id: marcador.id,
							plantioId: marcador.plantioId,
							macAddress: marcador.macAddress,
							hasPrecipitacao: marcador.hasPrecipitacao,
							existente: true,
						})
					})
			})

			this.parcelas = Array.from(new Set(this.parcelas.map((p) => p.id))).map((id) => {
				return {
					area: this.parcelas.find((p) => p.id === id).area,
					codigo: this.parcelas.find((p) => p.id === id).codigo,
					coordenadaX: this.parcelas.find((p) => p.id === id).coordenadaX,
					coordenadaY: this.parcelas.find((p) => p.id === id).coordenadaY,
					dataDeFechamento: this.parcelas.find((p) => p.id === id).dataDeFechamento,
					estratoFlorestalId: this.parcelas.find((p) => p.id === id).estratoFlorestalId,
					formato: this.parcelas.find((p) => p.id === id).formato,
					id: this.parcelas.find((p) => p.id === id).id,
					plantioId: this.parcelas.find((p) => p.id === id).plantioId,
					icon: this.parcelas.find((p) => p.id === id).icon,
					macAddress: this.parcelas.find((p) => p.id === id).macAddress,
					hasPrecipitacao: this.parcelas.find((p) => p.id === id).hasPrecipitacao,
					existente: this.parcelas.find((p) => p.id === id).existente,
				}
			})

			this.parcelas.forEach((parcela) => (parcela.infoOpened = false))
		},
		handleResponseInventarioPilha(ordemDeServicoDePilha) {
			this.ordemDeServicoDePilha = ordemDeServicoDePilha
		},
		getInventarioFlorestalDeQualidade(ordemServicoId, estratoFlorestalId) {
			getPlanejamentoDeInventarioFlorestalDeQualidade(ordemServicoId, estratoFlorestalId).then(
				(response) => {
					this.handleResponseInventario({ data: response.data })

					var idsDePlantios = JSON.parse(response.data.result.maps[0].plantios).features.map(
						(feature) => feature.properties.idPlantio,
					)

					recuperarMaiorNumeroDeCodigoDeParcelaParaOPlantio(idsDePlantios).then((response) => {
						this.codigoDeParcelaEmUsoNoBanco = response.data
					})
				},
			)
		},
		getInventarioFlorestalInstalacao(ordemServicoId, estratoFlorestalId) {
			getPlanejamentoDeInventarioFlorestalInstalacao(ordemServicoId, estratoFlorestalId).then(
				(response) => {
					this.handleResponseInventario({ data: response.data })

					var idsDePlantios = JSON.parse(response.data.result.maps[0].plantios).features.map(
						(feature) => feature.properties.idPlantio,
					)

					recuperarMaiorNumeroDeCodigoDeParcelaParaOPlantio(idsDePlantios).then((response) => {
						this.codigoDeParcelaEmUsoNoBanco = response.data
					})
				},
			)
		},
		getInventarioFlorestalContinuo(ordemServicoId, estratoFlorestalId) {
			getPlanejamentoDeInventarioFlorestalContinuo(ordemServicoId, estratoFlorestalId).then(
				(response) => {
					this.handleResponseInventario({ data: response.data })

					var idsDePlantios = JSON.parse(response.data.result.maps[0].plantios).features.map(
						(feature) => feature.properties.idPlantio,
					)

					recuperarMaiorNumeroDeCodigoDeParcelaParaOPlantio(idsDePlantios).then((response) => {
						this.codigoDeParcelaEmUsoNoBanco = response.data
					})
				},
			)
		},
		getInventarioFlorestalPreCorte(ordemServicoId, estratoFlorestalId) {
			getPlanejamentoDeInventarioFlorestalPreCorte(ordemServicoId, estratoFlorestalId).then(
				(response) => {
					this.handleResponseInventario({ data: response.data })

					var idsDePlantios = JSON.parse(response.data.result.maps[0].plantios).features.map(
						(feature) => feature.properties.idPlantio,
					)

					recuperarMaiorNumeroDeCodigoDeParcelaParaOPlantio(idsDePlantios).then((response) => {
						this.codigoDeParcelaEmUsoNoBanco = response.data
					})
				},
			)
		},

		getPlanejamentoSingleTrees(ordemServicoId, estratoFlorestalId) {
			getPlanejamentoAmostrasSingleTrees(ordemServicoId, estratoFlorestalId).then((response) => {
				this.handleResponseInventario({ data: response.data })
			})

			recuperarNumeroDeFustesDoPlantio(estratoFlorestalId).then((response) => {
				this.numeroDeFustes = response.data !== '' ? response.data : undefined
			})
		},

		getPlanejamentoConcentradorLongRange(ordemServicoId, estratoFlorestalId) {
			getPlanejamentoConcentradorLongRangeInstalacao(ordemServicoId, estratoFlorestalId).then(
				(response) => {
					this.handleResponseInventario({ data: response.data })
				},
			)
		},

		getPlanejamentoOrdemDeServicoDePilha(ordemServicoId) {
			this.buscandoOrdemDePilha = true
			buscarPlanejamentoOrdemDeServicoDePilha(ordemServicoId).then((response) => {
				this.buscandoOrdemDePilha = false
				this.handleResponseInventarioPilha(response.data)
			})
		},

		/**
		 * Conta quantos marcadores (parcelas / amostras) existem dentro de todos os plantios
		 * @returns {Any} Resultado do contador
		 */
		contarQuantidadeDeMarcadoresEmTodosOsPlantio() {
			return this.getGeoJsonPtio.features.map((feature) => {
				return {
					idPlantio: feature.properties.idPlantio,
					codigoPlantio: feature.properties['Codigo Plantio'],
					totalDeMarcadores: this.contarQuantidadeDeMarcadoresNoPlantio(
						feature.properties.idPlantio,
					),
				}
			})
		},

		/**
		 *  Conta quantos marcadores existem em um plantio especifico
		 * @param {Id do plantio} plantioId
		 */
		contarQuantidadeDeMarcadoresNoPlantio(plantioId) {
			var marcadores = this.parcelas.map((parcela) =>
				turf.point([Number(parcela.coordenadaX), Number(parcela.coordenadaY)]),
			)

			var geojsonPlantio = this.getGeoJsonPtio.features.find(
				(feature) => feature.properties.idPlantio === plantioId,
			)

			const marcadoresDentroDoPlantio = marcadores.filter((marcador) =>
				turf.booleanPointInPolygon(marcador, geojsonPlantio.geometry),
			)

			return marcadoresDentroDoPlantio.length
		},

		adicionaParcela({
			codigo,
			coordenadaX,
			coordenadaY,
			plantioId,
			id,
			formato,
			estratoFlorestalId,
			dataDeFechamento,
			dataDeInstalacao,
			area,
			icon,
			infoOpened,
			macAddress,
			hasPrecipitacao,
			existente,
		}) {
			this.parcelas.push({
				codigo,
				coordenadaX,
				coordenadaY,
				plantioId,
				id,
				formato,
				estratoFlorestalId,
				dataDeFechamento,
				dataDeInstalacao,
				area,
				icon,
				infoOpened,
				macAddress,
				hasPrecipitacao,
				existente,
			})
		},
		baixarGeoJsonParcela() {
			let points = this.parcelas.map((parcela) =>
				turf.point([Number(parcela.coordenadaX), Number(parcela.coordenadaY)], parcela),
			)
			let multipoint = turf.featureCollection(points)

			download(
				JSON.stringify(multipoint),
				`Parcelas OS-${this.model.orsv_cd_codigo} ${
					this.model.orsv_ds_descricao
				} ${new Date().toLocaleDateString()}.json`,
				'application/json',
			)
		},
		async isPointInsideAnyPolygon(point, polygons) {
			let flag = false

			await polygons.features.forEach((plantio) => {
				let esta = turf.booleanPointInPolygon(point, plantio)
				if (esta) {
					flag = true
				}
			})

			return flag
		},
		isPointInBufferPoint(turfPoint) {
			var esta = []

			this.getGeoJsonBufferParcela.features.forEach((e) => {
				esta.push(turf.booleanPointInPolygon(turfPoint, e))
			})

			return esta.every((e) => e === false)
		},
		// Função que gera parcelas de modo Aleatório
		async gerarParcelasAleatorio() {
			let plantios = this.getGeoJsonPtio
			let realParcels = []
			let parcelas =
				this.model.orsv_nr_amostra_total -
				this.parcelas.filter((parcela) => parcela.existente).length
			let bbox = turf.bbox(plantios.geojson)

			if (Object.entries(this.getGeoJsonBufferTalhao).length) plantios = this.getGeoJsonBufferTalhao

			while (realParcels.length < parcelas) {
				let randomPoint = turf.randomPoint(1, { bbox: bbox })

				let esta = await this.isPointInsideAnyPolygon(randomPoint.features[0], plantios)
				let estaNoBuffer =
					this.model.orsv_cd_tipo_servico === '003' && this.bufferParcela
						? await this.isPointInBufferPoint(randomPoint.features[0])
						: true

				if (esta && estaNoBuffer) {
					let point = randomPoint.features[0].geometry.coordinates
					realParcels.push({ lat: point[1], lng: point[0] })
				}
			}

			this.resetParcelas()

			//para cada ponto, cria-se um objeto de parcela, que por ser  automático conta com apenas coordenadas, codigo e id de plantio
			realParcels.forEach((point) => {
				let coordenadaX = point.lng
				let coordenadaY = point.lat

				this.adicionaParcela({
					infoOpened: false,
					codigo: this.createCodigoParcela({
						coordenadaX,
						coordenadaY,
					}),
					coordenadaX,
					coordenadaY,
					plantioId: this.findPlantioGeoByPoint({ coordenadaX, coordenadaY }).properties.idPlantio,
					icon: this.iconeParcela({
						draggable: true,
						color: this.model.tpsv_cd_codigo === '003' ? 'red' : 'blue',
					}),
					id: uuidv4(),
				})
			})
		},
		async gerarParcelasSistematico() {
			let bbox = turf.bbox(this.getGeoJsonPtio.geojson)
			let bboxPoly = turf.bboxPolygon(bbox)
			let polyCoords = turf.getCoords(bboxPoly)
			let plantios = this.getGeoJsonPtio

			if (Object.entries(this.getGeoJsonBufferTalhao).length) plantios = this.getGeoJsonBufferTalhao

			const pontosBbox = await this.getRandomPoints(polyCoords)

			const gridPoints = await this.getGridPoints(pontosBbox)

			let uniqueParcels = await this.getUniqueParcels(gridPoints)

			const turfPoints = await this.LatLngToTurfPoints(uniqueParcels)

			const realPoints = await this.getPointsInsidePolygon(plantios, turfPoints)

			this.resetParcelas()
			realPoints.forEach((point) => {
				let coordenadaX = point.lng
				let coordenadaY = point.lat

				this.adicionaParcela({
					infoOpened: false,
					codigo: this.createCodigoParcela({
						coordenadaX,
						coordenadaY,
					}),
					coordenadaX,
					coordenadaY,
					plantioId: this.findPlantioGeoByPoint({ coordenadaX, coordenadaY }).properties.idPlantio,
					icon: this.iconeParcela({
						draggable: true,
						color: this.model.tpsv_cd_codigo === '003' ? 'red' : 'blue',
					}),
					id: uuidv4(),
				})
			})
		},
		async gerarParcelasAleatorioSistematico() {
			let bbox = turf.bbox(this.getGeoJsonPtio.geojson)

			let bboxPoly = turf.bboxPolygon(bbox)
			let polyCoords = turf.getCoords(bboxPoly)
			let plantios = this.getGeoJsonPtio

			if (Object.entries(this.getGeoJsonBufferTalhao).length) plantios = this.getGeoJsonBufferTalhao

			const pontosBbox = await this.getRandomPoints(polyCoords)

			const gridPoints = await this.getGridPoints(pontosBbox)

			let uniqueParcels = await this.getUniqueParcels(gridPoints)

			let aleat = await this.aleatorizaGridPoints(uniqueParcels)

			const turfPoints = await this.LatLngToTurfPoints(aleat)

			const realPoints = await this.getPointsInsidePolygon(plantios, turfPoints)

			this.resetParcelas()
			realPoints.forEach((point) => {
				let coordenadaX = point.lng
				let coordenadaY = point.lat

				this.adicionaParcela({
					infoOpened: false,
					codigo: this.createCodigoParcela({
						coordenadaX,
						coordenadaY,
					}),
					coordenadaX,
					coordenadaY,
					plantioId: this.findPlantioGeoByPoint({ coordenadaX, coordenadaY }).properties.idPlantio,
					icon: this.iconeParcela({
						draggable: true,
						color: this.model.tpsv_cd_codigo === '003' ? 'red' : 'blue',
					}),
					id: uuidv4(),
				})
			})
		},
		resetParcelas() {
			let parcelasExistentes = this.parcelas.filter((parcela) => !parcela.icon.draggable)
			this.parcelas.splice(0, this.parcelas.length)
			parcelasExistentes.forEach((parcelaExistente) => this.parcelas.push(parcelaExistente))
		},
		// Tem o papel de gerar o buffer, exista algum valor diferente de 0
		async bufferGenerator() {
			const UMA_MILHA_EM_METROS = 1609.344
			let distanciaBuffer =
				this.model.orsv_nr_buffer > 0
					? (this.model.orsv_nr_buffer / UMA_MILHA_EM_METROS) * -1
					: this.model.orsv_nr_buffer / UMA_MILHA_EM_METROS
			let buffer = undefined

			if (distanciaBuffer) {
				let buffered = await turf.buffer(this.getGeoJsonPtio.geojson, distanciaBuffer, {
					units: 'miles',
				})

				buffered.features.forEach((plantio) => {
					plantio.properties.codigo = 'buffer'
				})

				buffer = buffered
			}

			this.setGeoJsonBufferTalhao({
				features: buffer.features.map((feature) => {
					return {
						coordinates: feature.geometry.coordinates,
						geometry: feature.geometry,
						properties: feature.properties,
						type: feature.geometry.type,
					}
				}),
				geojson: buffer,
				properties: {},
			})
			return buffer
		},
		// verifica quais pontos aleatorizados estão dentro dos talhões úteis, retorna uma lista de pontos que
		async getPointsInsidePolygon(ptiosGeoJson, turfPoints) {
			var realPoints = []
			let isPointInBuffer = true

			ptiosGeoJson.features.forEach((e) => {
				turfPoints.forEach((el) => {
					let pontoEsta = turf.booleanPointInPolygon(el, e)
					if (this.model.orsv_cd_tipo_servico === '003' && this.bufferParcela)
						isPointInBuffer = this.isPointInBufferPoint(el)
					if (pontoEsta && isPointInBuffer) {
						realPoints.push({
							lat: el.geometry.coordinates[1],
							lng: el.geometry.coordinates[0],
						})
					}
				})
			})

			return realPoints
		},
		// função para converter LatLng para pontos Turf, retorna uma Lista
		async LatLngToTurfPoints(aleatPoints) {
			var turfPoints = []
			await aleatPoints.forEach(async (e) => {
				var ponto = await turf.point([e.lat, e.lng])
				turfPoints.push(ponto)
			})

			return turfPoints
		},
		// retorna um valor aleatório entre 0 e a distância entre parcelas/amostras exclusive
		getRandomDistance() {
			let gridDistance = this.distanceBetweenParcels()
			const UMA_MILHA_EM_METROS = 1609.344
			return isNaN(gridDistance) ? 0 : Math.random() * ((gridDistance * UMA_MILHA_EM_METROS) / 2)
		},

		// aleatoriza pontos do grid. Usado no Aleatório e duas fases
		async aleatorizaGridPoints(pontos) {
			let randompoints = []

			await pontos.forEach(async (e) => {
				let lat = this.getRandomDistance()
				let lng = this.getRandomDistance()

				let deg = new UTMConv.DegCoords(e.lat, e.lng, 'wgs84')

				let utm = deg.to_utm()

				utm.easting = utm.easting + lat
				utm.northing = utm.northing + lng

				let newlatlng = utm.to_deg()

				await randompoints.push({ lat: newlatlng.latd, lng: newlatlng.lngd })
			})

			return randompoints
		},

		// Retira parcelas duplicadas
		getUniqueParcels(parcels) {
			let uniqueParcels = []
			let stringParcels = []

			parcels.forEach((e) => {
				stringParcels.push(`(${e[1]},${e[0]})`)
			})

			const uniqueStrings = [...new Set(stringParcels.map((item) => item))]

			uniqueStrings.forEach((e) => {
				let semp = e.replace(/[()\s]+/g, '')
				let toarr = semp.split(',')
				uniqueParcels.push({ lat: Number(toarr[0]), lng: Number(toarr[1]) })
			})

			return uniqueParcels
		},
		// Função retorna distância do espaçamento do Grid
		distanceBetweenParcels() {
			var quantidadeDeParcelasJaNoBanco = this.parcelas.filter(
				(parcela) => parcela.existente,
			).length
			var hecParc = parseFloat(
				this.model.orsv_nr_intensidade_amostral === ''
					? '1'
					: (
							this.areaEstrato /
							(this.model.orsv_nr_amostra_total - quantidadeDeParcelasJaNoBanco)
						).toFixed(2),
			)
			const UMA_MILHA_EM_METROS = 1609.344
			var times = hecParc * 10000
			var distancia = Math.sqrt(times)
			var cellSide = distancia / UMA_MILHA_EM_METROS

			return cellSide
		},
		// Função para separar os pontos no grid
		getGridPoints(pontosBbox) {
			let gridPoints = []

			let cellSide = this.distanceBetweenParcels()

			if (isNaN(cellSide)) {
				//TODO avisar que instensidade amostral é maior
			} else {
				let squareGrid = turf.squareGrid(pontosBbox, cellSide, {
					units: 'miles',
				})

				squareGrid.features.forEach((e) => {
					e.properties = { name: 'grid' }
					e.geometry.coordinates[0].forEach(async (el) => {
						let parcela = [el[1], el[0]]
						gridPoints.push(parcela)
					})
				})
			}

			return gridPoints
		},
		// Função que retorna extremos diagonais aleatorizados
		async getRandomCoords(e, index) {
			let rLatLng = await this.getRandomLatLng()
			let rLat = rLatLng.rLat
			let rLng = rLatLng.rLng

			if (index == 3) {
				if (rLng > 0) {
					rLng *= -1
				}
				if (rLat < 0) {
					rLat *= -1
				}
			} else {
				if (rLng < 0) {
					rLng *= -1
				}
				if (rLat > 0) {
					rLat *= -1
				}
			}

			let lat = e[0] * -1
			let lng = e[1] * -1

			return {
				ponto: index,
				latitude: (lat + rLat) * -1,
				longitude: (lng + rLng) * -1,
			}
		},
		// retorna coordenadas aleatorizadas para criar pontos diagonais
		async getRandomLatLng() {
			var hecLat = 0.000898316
			var hecLng = 0.000959004
			var startRandomLat = Math.random() * (Math.floor(Math.random() * 2) == 1 ? 1 : -1) * hecLat
			var startRandomLng = Math.random() * (Math.floor(Math.random() * 2) == 1 ? 1 : -1) * hecLng

			return await { rLat: startRandomLat, rLng: startRandomLng }
		},
		async getRandomPoints(coords) {
			let randomPoints = []

			const cPS = await this.getRandomCoords(coords[0][1], 1)

			const cPI = await this.getRandomCoords(coords[0][3], 3)

			const pontoSuperior = turf.point([cPS.latitude, cPS.longitude])
			const pontoInferior = turf.point([cPI.latitude, cPI.longitude])

			randomPoints.push(pontoSuperior)
			randomPoints.push(pontoInferior)

			let pontosBbox = turf.bbox(turf.featureCollection(randomPoints))

			return pontosBbox
		},
		calcularCoeficienteVariacao() {
			let n, cv_perc, ic_perc, N
			let ns = 0.05

			if (this.coeficienteVariacao.amostrasReferencia !== null) {
				if (this.coeficienteVariacao.amostrasReferencia > 1) {
					n = this.coeficienteVariacao.amostrasReferencia
				} else {
					console.log('numero de amostras de referencia devem ser maior que 1')
				}
			}
			if (this.coeficienteVariacao.coeficiente) {
				if (this.coeficienteVariacao.coeficiente > 0) {
					cv_perc = this.coeficienteVariacao.coeficiente
				} else {
					console.log('coeficiente deve ser maior que 0')
				}
			}
			if (this.coeficienteVariacao.targetErro) {
				if (this.coeficienteVariacao.targetErro > 0) {
					ic_perc = this.coeficienteVariacao.targetErro
				} else {
					console.log('target de erro deve ser maior que 0')
				}
			}

			if (n > 1 && cv_perc > 0 && ic_perc > 0) {
				N = this.isSingleTrees ? this.numeroDeFustes : this.areaEstrato

				for (let i = 0; i < 50; i++) {
					n =
						(Math.pow(jStat.studentt.inv(ns, n - 1), 2) * Math.pow(cv_perc, 2)) /
						(Math.pow(ic_perc, 2) +
							(Math.pow(jStat.studentt.inv(ns, n - 1), 2) * Math.pow(cv_perc, 2)) / N)
				}
				this.model.orsv_nr_intensidade_amostral = Math.ceil(this.areaEstrato / n)

				this.model.orsv_nr_amostra_total = n.toFixed(0)
			}
		},

		/**
		 * Verifica se um determinado ponto (coordenadas) está presente nos limites de um poligono.
		 * Recebe um objeto com os parametros abaixo:
		 * @param {Number | String} coordenadaX coordenada x do ponto em que se deseja verificar a existência no poligono
		 * @param {Numebr | String} coordenadaY coordenada y do ponto em que se deseja verificar a existência no poligono
		 * @param {GeoJSON} geojson geojson do tipo polygono que no caso representa o plantio
		 * @returns {Boolean} retorna true, caso a coordenada esteja dentro dos limites do geojson, false caso contrário
		 */
		isPointInPlantio({ coordenadaX, coordenadaY, geojson }) {
			return turf.booleanPointInPolygon(
				turf.point([Number(coordenadaX), Number(coordenadaY)]),
				geojson,
			)
		},

		/**
		 * Verifica em qual plantio o ponto fornecido está contido e retorna o retorna.
		 * Recebe um objeto com os parametros abaixo:
		 * @param {Number | String} coordenadaX coordenada x do ponto em que se quer consultar qual o plantio
		 * @param {Number | String} coordenadaY coordenada y do ponto em que se quer consultar qual o plantio
		 * @returns {Any} Objeto contendo as informacoes do plantio de acordo com a coordenada
		 */
		findPlantioGeoByPoint({ coordenadaX, coordenadaY }) {
			return this.getGeoJsonPtio.features.find((geojson) => {
				var marcador = turf.point([Number(coordenadaX), Number(coordenadaY)])
				return turf.booleanPointInPolygon(marcador, geojson.geometry)
			})
		},

		bufferParcelaGenerator() {
			let points = this.parcelasExistentes.map((p) => turf.point([p.coordenadaX, p.coordenadaY]))
			const UMA_MILHA_EM_METROS = 1609.344
			let area = this.bufferParcela / UMA_MILHA_EM_METROS
			var options = {
				units: 'miles',
				properties: { codigo: 'buffer' },
			}
			var pointBuffers = turf.featureCollection(points.map((p) => turf.circle(p, area, options)))

			this.setGeoJsonBufferParcela({
				features: pointBuffers.features.map((feature) => {
					return {
						coordinates: feature.geometry.coordinates,
						geometry: feature.geometry,
						properties: feature.properties,
						type: feature.geometry.type,
					}
				}),
				geojson: pointBuffers,
				properties: {},
			})
		},

		createCodigoParcela(parcela) {
			//TODO levantar casos de uso onde será necessário atualizar os códigos das parcelas
			let index

			const plantio = this.findPlantioGeoByPoint({
				coordenadaX: parcela.coordenadaX,
				coordenadaY: parcela.coordenadaY,
			})

			const relacao = this.relacaoPlantioParcela.find(
				(p) => p.idPlantio === plantio.properties.idPlantio,
			)

			const codigoTalhao = this.getGeoJsonPtio.features.find(
				(geojson) => geojson.properties.idPlantio === relacao.idPlantio,
			).properties['Codigo do Talhao']

			const codigos = this.isSingleTrees
				? relacao.parcelas.map((parcela) => parcela.codigo)
				: relacao.parcelas
						.map((parcela) => parcela.codigo)
						.filter((c) => c != undefined && c != 'NaN')
						.map((c) => Number(c.replace(`T${codigoTalhao}_P`, '')))
						.filter((c) => !isNaN(c))

			if (codigos.length) index = Math.max.apply(null, codigos)
			else index = relacao.parcelas.indexOf(parcela)

			index = index === -1 ? index + 2 : index + 1

			// Caso o plantio já tenha parcelas no banco busca quais sao esses códigos, caso não possua retorna uma lista vazia, significando que qualquer valor pode ser atribuido
			var codigosDeParcelasExistentesNoPlantio = this.codigoDeParcelaEmUsoNoBanco.find(
				(codigoParcelaAPartirDe) =>
					codigoParcelaAPartirDe.plantioId == plantio.properties.idPlantio,
			)
				? this.codigoDeParcelaEmUsoNoBanco.find(
						(codigoParcelaAPartirDe) =>
							codigoParcelaAPartirDe.plantioId == plantio.properties.idPlantio,
					).codigosExistentes
				: []

			while (codigosDeParcelasExistentesNoPlantio.includes(index)) {
				index++
			}

			return this.isSingleTrees ? index : `T${codigoTalhao}_P${index}`
		},
	},
	computed: {
		plotsWithoutCoords() {
			if (this.parcelas.length === 0) return false
			return this.parcelas.filter(({ coordenadaX, coordenadaY }) => !coordenadaX || !coordenadaY)
		},
		concentradoresToCreateNovas() {
			return this.parcelas
				.filter((concentrador) => !concentrador.id)
				.map((concentrador) => {
					return {
						id: uuidv4(),
						coordenadaX: concentrador.coordenadaX.toString(),
						coordenadaY: concentrador.coordenadaY.toString(),
						plantioId: concentrador.plantioId,
						talhaoId: concentrador.talhaoId,
						fazendaId: this.model.fk_fzda_fazenda,
						hasPrecipitacao: concentrador.hasPrecipitacao || false,
					}
				})
		},
		isSingleTrees() {
			return this.model.tpsv_cd_codigo === '007'
		},
		isInventarioDePilha() {
			return this.model.tpsv_cd_codigo === '018'
		},
		isColetaDeCubagem() {
			return this.model.tpsv_cd_codigo === '005'
		},
		isColetaSingleTrees() {
			return this.model.tpsv_cd_codigo === '008'
		},
		parcelasExistentes() {
			return this.parcelas.filter((f) => !f.icon.draggable)
		},
		relacaoPlantioParcela() {
			return this.getGeoJsonPtio.features.map((feature) => {
				const { idPlantio } = feature.properties
				return {
					idPlantio,
					parcelas: this.parcelas.filter((parcela) =>
						this.isPointInPlantio({
							coordenadaX: parcela.coordenadaX,
							coordenadaY: parcela.coordenadaY,
							geojson: feature,
						}),
					),
				}
			})
		},
		google: gmapApi,
		...mapGetters('moduleImportShape', [
			'areaEstrato',
			'getGeoJsonBufferTalhao',
			'getGeoJsonBufferParcela',
			'getGeoJsonFzda',
			'getGeoJsonTlho',
			'getGeoJsonPtio',
			'isGeoJsonPlantioEmpty',
		]),
	},
	watch: {
		coeficienteVariacao: {
			handler() {
				this.calcularCoeficienteVariacao()
			},
			deep: true,
		},

		'model.orsv_nr_buffer'(value) {
			if (value) {
				this.bufferGenerator()
				this.resetParcelas()
			} else this.setGeoJsonBufferTalhao({})
		},
		bufferParcela(value) {
			if (value) this.bufferParcelaGenerator()
			else this.setGeoJsonBufferParcela({})
		},
	},
}

export default mixins
